/*
 * Project: LegalPlace assistant
 * File: src\App.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */
import 'es6-promise/auto';
import 'fetch-ie8';
import 'core-js/es6/map';
import 'core-js/es6/set';

// import 'react-polyfill'
import 'babel-polyfill';
import 'raf/polyfill';
import './shims_for_IE';
import React, { Component } from 'react';
import {
    Router,
    Switch,
    Route,
    Redirect,
} from 'react-router-dom';

// Redux phase
import { Provider } from 'react-redux';
import Mousetrap from 'mousetrap';

import PreviewModalWrapper from './components/preview_modal_wrapper'
import LpErrorBar from './components/error_bar';
import { store } from './globals';
import WizardContainer from './components/wizard_container';

// get the style.
import './App.css';
import CheckoutWrapper from './components/buy/checkout_wrapper';
import PacksWrapper from './components/buy/packs_wrapper';
import RepriseWizard from './components/reprise_wizard';
// test

// import { Map } from 'immutable';
import { showContactUs, showLoginModal } from './redux/actions/account_settings';
import { ceTogglePack } from './redux/actions/checkout_operations';

import AbTest from './tracking/abTest';
import { lpw } from './logic/wording';

import lpApp from './app/lp_app';
import History from './logic/utils/history';

import ConditionsEvo from './logic/condition_evo';
import { LpContactUs } from './components/contact_us';
import { SingupModal } from './components/singup_modal';
import { LoginModal } from './components/login_modal';
import OnboardingModal from './components/OnboardingModal';
import { setCookieIfAlias } from './manager/aliasManager';
import GenerationLoader from './components/generation_loader/generation_loader';
import {
  wizardxAbOptions,
} from "./constants/ABTestConstants";
import lpevents from './tracking/lpevents';
import UpsellEc from '../src/components/buy/Upsell-EC/upsell-Ec'
import { setAbTestArtisanPricing } from './components/utils/abTestInstance';
import Cookies from 'universal-cookie';
const cookies = new Cookies()

lpApp.initializeStore(store);


window.ConditionsEvo = ConditionsEvo;
window.lpApp = lpApp;
window.nbr_forced = 0;
window.lpw = lpw;
window.repeated = false;

const lpAb = new AbTest();





const {
  testName: wizardxTestName,
  testVarOld: wizardxVarOld,
  testShareOld: wizardxShareOld,
} = wizardxAbOptions




if (typeof (lpAb) !== 'undefined') {

  // AB test wizardx
  const cookies = new Cookies();

  // Making sure we're not overriding AB test variable in case
  // user comes from wizardx
  if(cookies.get('X-Source') !== 'S3-lp-prod-builds/wizardxs/wizard-lp'){
    lpAb.registerTest(wizardxTestName);
    lpAb.registerVar(wizardxVarOld, wizardxShareOld);
    window.wizardX = lpAb.getVar(wizardxTestName);
  }

  // Ab-Test Artisan Pricing with Cookies
  setAbTestArtisanPricing()
  // AB Test for Extra Pack display on SAS/SARL/SASU/EURL
}



const wizardApiPricing = new AbTest()

if (typeof (wizardApiPricing) !== 'undefined') {
  wizardApiPricing.registerFromCookie('wizard')
}

class App extends Component {
  constructor(props) {
    super(props);
    this.Aw = this.Aw.bind(this);
    setCookieIfAlias()

    window.baseApp = this;
    this.app = 0;
    this.state = {
      app: 0,
      fullWidth: false,
      showOnboardingModal: false
    };
    lpApp.redux_subscribe(this.Aw);
  }

  componentDidMount() {
    // case of sidebar
    function getElHeight(el) {
      const positionInfo = el.getBoundingClientRect();
      return positionInfo.height;
    }

    const wizard = document.querySelector('.wizard');
    if (window.location.href.includes('paiement') || window.location.href.includes('checkout'))
      lpevents.register({checkoutVersion: 'legacy'});

    History.history.listen((location, action) => {
      lpevents.trackGTMFunnel(location.pathname)
    })
    const asideList = document.querySelector('.forcing-summary ul');
    if (asideList) asideList.style.height = `${getElHeight(wizard)}px`;
    // Changing body class from forcing if it's normal
    if (lpApp.isPayed) {
      document.body.classList.add('wz-forcing');
    }


    this.setShowOnboardingModal()
  }

  componentWillUpdate() {
    if (
      document.activeElement
      && document.activeElement !== document.body
      && document.activeElement.tagName
      && (document.activeElement.tagName.toLowerCase() === 'input' || document.activeElement.tagName.toLowerCase() === 'select')
    ) {
      const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
      const { top } = document.activeElement.getBoundingClientRect();
      if (h - top <= 150) {
        window.scrollBy(0, 200);
      }
    }
  }

  Aw() {
    if (lpApp.isPrerender === true) return;

    const ass = lpApp.getState().appstate;

    if (ass !== this.state.app) this.setState({ app: ass });

    this.setState({ fullWidth: store.getState().contract.fullWidth });
    if (lpApp.getState().contract.fullWidth) {
      document.body.classList.add('full-wizard');
    }
    this.forceUpdate();
  }

  setShowOnboardingModal = () => {
    const { isPayed } = lpApp
    // Don't show onboarding when comming from wizardx
    // @TODO remove when implemented on wizardx
    const wizardxCookie = cookies.get('X-Source')
    if (wizardxCookie && wizardxCookie.split('/').length > 1 && wizardxCookie.split('/')[1] === 'wizardxs')
      localStorage.setItem('userHasSeenOnboardingCoursier', 'true')

    const hasUserSeenOnboarding = JSON.parse(localStorage.getItem("userHasSeenOnboardingCoursier"));
    const shouldShowOnboarding =
      !hasUserSeenOnboarding &&
      !isPayed
    if (shouldShowOnboarding) {
      this.setState({ showOnboardingModal: true });
    }
  }

  closeOnboardingModal = () => {
    this.setState({showOnboardingModal: false })
    localStorage.setItem('userHasSeenOnboardingCoursier', 'true')
    localStorage.removeItem("onboardingCoursierStep");
  }
    render() {
      let reprise = (store.getState().contract.reprise_wizard);
      const { showOnboardingModal } = this.state;
      const { contractMetaId } = lpApp;
      return (
        <Provider store={store}>
          <div>
            {reprise ? (
              <RepriseWizard />
            ) : (
              <Router history={History.history}>
                <Switch>
                  <Route path="/contrats/:name/:id/paiement" component={PacksWrapper}/>
                  {lpApp.isPayed
                  ? <Redirect from="/contrats/:name/:id/checkout" to={{pathname: "/contrats/:name/continuer/:id/", search: location.search}}/>
                  : <Route path="/contrats/:name/:id/checkout" component={CheckoutWrapper}/>}
                  {lpApp.isPayed
                  ? <Redirect from="/contrats/:name/:id/expert-comptable" to={{pathname: "/contrats/:name/continuer/:id/", search: location.search}}/>
                  : <Route path="/contrats/:name/:id/expert-comptable" component={UpsellEc} />}

                  <Route path="/contrats/:name/continuer/:id/:sectionId" component={WizardContainer}/>
                  <Route path="/contrats/:name/continuer/:id/" component={WizardContainer}/>
                  <Route path="/contrats/:name/creer/:sectionId" component={WizardContainer}/>
                  <Redirect from="/contrats/:name/creer/" to={{pathname: "/contrats/:name/creer/1", search: location.search}}/>
                  <Route path="/contrats/:name/paiement" component={CheckoutWrapper}/>
                  <Route path="/prerender_react/contract_output" component={PreviewModalWrapper}/>
                  <Route path="/contrats/:name/:id/generation" component={GenerationLoader}/>
                </Switch>
              </Router>
            )}

            <LpErrorBar />
            <LpContactUs />
            <LoginModal />
            <SingupModal />
            {showOnboardingModal &&
              contractMetaId &&
              contractMetaId === 302 && (
                <OnboardingModal
                  contractMetaId={contractMetaId}
                  closeOnboardingModal={this.closeOnboardingModal}
                />
              )}
          </div>
        </Provider>
      );
    }
}

function contactezNous() {
  store.dispatch(showContactUs(true));
}
// document.getElementById('footer-compact').setAttribute('style', "display: block");
// document.getElementById('partners-logos').setAttribute('style', "display: block");
// document.getElementById("contactez-nous").addEventListener("click", contactezNous);
// document.getElementById("contactez-nous-footer").addEventListener("click", contactezNous);

function login() {
  store.dispatch(showLoginModal(true));
}

const connexionBtn = document.getElementById("connexion");
if (connexionBtn) {
  connexionBtn.addEventListener("click", login);
}

window.checkout_step = '';

window.onpopstate = function (event) {
  if (event.state) {
    if (event.state.checkout_step === 'checkout') {
      store.dispatch(ceTogglePack(false));
    } else if (event.state.checkout_step === 'paiement') {
      store.dispatch(ceTogglePack(true));
    }
  }
};

Mousetrap.bind('g o d l d', () => {
  // Doing it the dirty way
  console.log('here?');
  const t0 = performance.now();
  while (document.querySelector('.btn.btn-next.on') && document.querySelector('.btn.btn-next.on').innerText.toLowerCase() === 'suivant') document.querySelector('.btn.btn-next.on').click();
  const t1 = performance.now();

  console.log('GODLD TOOK ', t1 - t0, ' ms');
});

export default App;



// WEBPACK FOOTER //
// ./src/App.js